// extracted by mini-css-extract-plugin
export var copyIcon = "_y8-2";
export var discountCard = "_y8-0";
export var discountCode = "_y8-3";
export var discountContent = "_y8-1";
export var loadingCard = "_y8-4";